/*
  Popup 1 quiz controller.

  Knows nothing about money. It turns two answers plus the selected tier's bag count into a
  spec string, writes it onto one hidden preset tile and clicks it; heist-presets.js then
  drives the engine's steppers. If pricing logic appears in here, it is in the wrong file.

  THE CATALOGUE CONSTRAINS THE GRID. Blueprint is decaf-only, and Smooth Talker 1/4 Caf is
  the ONLY caffeinated bag, so any answer asking for caffeine pulls in Smooth Talker even
  from someone who drinks it black. A real product limit, not a bug.

  ALLOCATION IS AN EVEN SPREAD ACROSS ROLES, not a hand-written grid:
    drink   black -> [Blueprint]   milk -> [Smooth Talker]   both -> [Smooth Talker, Blueprint]
    caffeine  none   -> spread the bags across those roles
              little -> the whole box in 1/4 Caf when the roast has a caffeinated twin
                        ("with milk"); otherwise exactly one 1/4 Caf and spread the rest
              each   -> the 1/4 Caf joins as an equal role and everything spreads evenly

  ROLE ORDER DECIDES WHO GETS THE ODD BAG. "Both" lists Smooth Talker FIRST, so three bags
  resolve to 2 Smooth Talker + 1 Blueprint rather than the reverse. Smooth Talker is the
  everyday cup and the only roast with a caffeine option, so it should win the tie. Flipping
  this array is the mechanism for allocation - do not special-case answer combinations to
  change WHO gets a bag.

  The one branch that is not an even spread is "with milk" + "a little", and it is a catalogue
  rule rather than a special case: that roast has a caffeinated twin, so "a little" is expressed
  IN the roast instead of by adding a different bag. See the comment at that branch.

  DISPLAY ORDER IS FIXED (Blueprint, Smooth Talker, 1/4 Caf) even though allocation order is
  not, so bags do not jump around the row as answers change.

  At three bags "a little" and "some of each" still collide for BLACK and BOTH - with three
  SKUs and three bags there is no room for them to differ, and inventing a difference would be
  dishonest. They no longer collide for "with milk": little is 3x 1/4 Caf, each is 2 Smooth
  Talker + 1 1/4 Caf.
*/
(function () {
  var POLL_MS = 120, MAX_TRIES = 50, wired = new WeakSet();

  function spread(list, n, counts) {
    if (!list.length || n <= 0) return;
    var base = Math.floor(n / list.length), rem = n % list.length;
    list.forEach(function (id, i) {
      var k = base + (i < rem ? 1 : 0);
      if (k > 0) counts[id] = (counts[id] || 0) + k;
    });
  }

  function init(root) {
    var sel = root.querySelector("[data-b2-quiz]");
    var ui = root.querySelector("[data-b2]");
    if (!sel || !ui || wired.has(sel)) return;
    wired.add(sel);

    var ART = {};
    var artEl = sel.querySelector("[data-b2-quiz-art]");
    if (artEl) { try { ART = JSON.parse(artEl.textContent); } catch (e) { ART = {}; } }

    var IDS = {
      bp: sel.dataset.idBlueprint || "",
      st: sel.dataset.idSmoothDecaf || "",
      qc: sel.dataset.idQuarterCaf || ""
    };
    var CUPS_PER_BAG = Number(ui.dataset.cupsPerBag) || 0;
    var tile = sel.querySelector("[data-b2-quiz-tile]");
    var state = { drink: "both", caf: "none" };

    function bags() {
      var b = ui.querySelector("[data-b2-tier][aria-pressed='true']");
      return b ? (parseInt(b.dataset.bags, 10) || 0) : 0;
    }

    function allocate(n) {
      /* Smooth Talker leads on "both" so it takes the odd bag. */
      var roles = state.drink === "black" ? [IDS.bp]
        : state.drink === "milk" ? [IDS.st]
        : [IDS.st, IDS.bp];
      roles = roles.filter(Boolean);
      if (!roles.length) roles = [IDS.st || IDS.bp].filter(Boolean);

      var counts = {};
      if (state.caf === "none" || !IDS.qc) {
        spread(roles, n, counts);
      } else if (state.caf === "little") {
        /* "A LITTLE" MEANS A LITTLE IN EVERY CUP, not one caffeinated bag among decafs -
           whenever the chosen roast has a caffeinated twin.

           "With milk" resolves to Smooth Talker, and 1/4 Caf IS Smooth Talker with a quarter of
           the caffeine. So the whole box becomes 1/4 Caf: same roast, same cup, consistent from
           the first bag to the last. The old behaviour gave 2 decaf + 1 quarter-caf, which meant
           most cups had no caffeine at all - not what the answer asked for.

           "Black" and "Both" still take exactly one 1/4 Caf, because Blueprint has no
           caffeinated version. There is no way to express "a little" inside that roast, so the
           caffeine has to arrive as its own bag. */
        if (state.drink === "milk") {
          spread([IDS.qc], n, counts);
        } else {
          counts[IDS.qc] = 1;
          spread(roles, n - 1, counts);
        }
      } else {
        spread(roles.concat([IDS.qc]), n, counts);
        // "Some of each" must never resolve to no caffeine at all.
        if (!counts[IDS.qc]) {
          var donor = roles[roles.length - 1];
          if (donor && counts[donor] > 0) {
            counts[donor] -= 1;
            if (!counts[donor]) delete counts[donor];
            counts[IDS.qc] = 1;
          }
        }
      }

      // Stable display order, independent of who won the odd bag.
      var out = [];
      [IDS.bp, IDS.st, IDS.qc].forEach(function (id) {
        if (id && counts[id] > 0) out.push({ id: id, qty: counts[id] });
      });
      return out;
    }

    function esc(t) {
      return String(t == null ? "" : t).replace(/[&<>"]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
      });
    }

    function render(apply) {
      var n = bags();
      if (!n || !tile) return;
      var parts = allocate(n), html = "", total = 0;

      parts.forEach(function (p) {
        total += p.qty;
        var a = ART[p.id] || {};
        html += '<span class="b2__bag">'
          + '<span class="b2__bagart">'
          + (a.img ? '<img src="' + esc(a.img) + '" alt="" loading="lazy">' : "")
          + '<span class="b2__bagqty">' + p.qty + "&times;</span>"
          + "</span>"
          + '<span class="b2__bagname">' + esc(a.n) + "</span>"
          + (a.r ? '<span class="b2__bagroast">' + esc(a.r) + "</span>" : "")
          + '<span class="b2__bagopt">' + esc(a.o) + "</span>"
          + "</span>";
      });

      var out = sel.querySelector("[data-b2-quiz-bags]");
      if (out && out.innerHTML !== html) out.innerHTML = html;

      var cupEl = sel.querySelector("[data-b2-quiz-cups]");
      if (cupEl) cupEl.textContent = String(Math.round(total * CUPS_PER_BAG));

      tile.dataset.spec = parts.map(function (p) { return p.id + ":" + p.qty; }).join(",");
      if (apply !== false) tile.click();
    }

    sel.addEventListener("click", function (e) {
      if (e.target.closest("[data-b2-quiz-skip]")) {
        state.drink = "milk";
        state.caf = "none";
        sel.querySelectorAll("[data-quiz]").forEach(function (b) {
          b.setAttribute("aria-pressed", String(b.dataset.value === state[b.dataset.quiz]));
        });
        render();
        var confirm = sel.querySelector("[data-b2-selector-confirm]");
        if (confirm) confirm.click();
        return;
      }
      var opt = e.target.closest("[data-quiz]");
      if (!opt) return;
      var group = opt.dataset.quiz;
      if (state[group] === opt.dataset.value) return;
      state[group] = opt.dataset.value;
      sel.querySelectorAll('[data-quiz="' + group + '"]').forEach(function (b) {
        b.setAttribute("aria-pressed", String(b === opt));
      });
      render();
    });

    // The tier lives on the card and decides how many bags to allocate.
    ui.addEventListener("b2:tier", function () { render(); });

    render();
  }

  function boot() {
    document.querySelectorAll('buy-box[data-variation="presets"]').forEach(init);
  }
  function watch() {
    var tries = 0, t = setInterval(function () {
      if (++tries >= MAX_TRIES) clearInterval(t);
      boot();
    }, POLL_MS);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(); watch(); });
  } else { boot(); watch(); }
})();
